import Api from '../service/Api'

export default (
  headers = {
    'content-type': 'application/ld+json',
    'accept': 'application/ld+json',
  }
) => (new Api(headers))